import loadable from "@loadable/component";
import { useQueryClient } from "@tanstack/react-query";
import SwitchTab from "../../components/Reusable/SwitchTab";
import APIS from "../../constant/Endpoint";
import useDeleteHook from "../../customHooks/useDeleteHook";
import usePatchHook from "../../customHooks/usePatchHook";

const InventoryComponent = loadable(
  () => import("../../components/InventoryInfo")
);
const InventoryInfo = () => {
  const { mutateAsync: patchUser, isLoading } = usePatchHook({
    queryKey: ["inventory-info"],
  });
  const { mutateAsync, isLoading: isDeleting } = useDeleteHook({
    queryKey: ["inventory-info"],
  });
  const queryClient = useQueryClient();

  const handleIsActive = async (value: boolean, id: any) => {
    const payload = {
      is_active: value,
    };
    const url = `${APIS.PRODUCT}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.error(e);
    }
  };
  const handleIsTaxable = async (value: boolean, id: any) => {
    const payload = {
      is_taxable: value,
    };
    const url = `${APIS.PRODUCT}${id}/`;
    const formData = payload;
    try {
      const res = await patchUser({ url, formData });
      if (res?.status === 200) {
        await queryClient.refetchQueries({
          queryKey: ["inventory-info", `inventory-info-${id}`],
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleIsMaintainStock = async (value: boolean, id: any) => {
    const payload = {
      is_maintain_stock: value,
    };
    const url = `${APIS.PRODUCT}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.error(e);
    }
  };

  const handleDelete = async (id: any) => {
    const url = `${APIS.COA}${id}/`;
    try {
      await mutateAsync({ url, formData: {} });
    } catch (err) {
      console.error(err);
    }
  };
  const tabs = [
    {
      id: "inventory-info",
      label: "Inventory",
      href: "/accounting/inventory",
    },
    {
      id: "product-group",
      label: "Product Group",
      href: "/accounting/product-group",
    },
  ];

  return (
    <>
      <SwitchTab tabs={tabs} />
      <InventoryComponent
        handleIsActive={handleIsActive}
        handleDelete={handleDelete}
        handleIsMaintainStock={handleIsMaintainStock}
        handleIsTaxable={handleIsTaxable}
      />
    </>
  );
};

export default InventoryInfo;
